<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZWAj3p/tc-custom/9780547349510.jpg?1698107359579" alt="This image is the cover for the book Testament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Testament
      </h1>
      <p class="bookDescription body article font2">
        <b>A fictional biography of the earthly life of Jesus told from the perspectives of four fascinating figures, by the author of <i>Where She Has Gone</i>.</b><br/><br/>In powerful accounts colored by their own beliefs and devices, the following men and women tell the captivating story:<br/><br/>Yihuda of Qiryat (Judas Iscariot), a freedom fighter working for Rome’s overthrow who is drawn to the charismatic teacher; Miryam of Migdal (Mary Magdeline), a disciple who finds in Jesus’ presence the intellectual stimulation that society has denied her. Miryam (Mary), the mother of Jeus, who has a complex relationship with her precocious son, and Simon of Gergesa, a plainspoken shepherd who travels to Jerusalem and witnesses the last days of the Jewish preacher.<br/><br/>With exquisite detail, Nino Ricci offers a provocative portrait of the historical Jesus, an ordinary man living in a time of political turmoil and spiritual uncertainty.<br/><br/><b>Praise for <i>Testament</i></b><br/><br/><b>“A hypnotic, deeply lyrical presentation of four gospels . . . . A writer of impeccable craft . . . recreating, in his incantatory prose, the very aroma and the wild, sorcery-filled world through which Jesus walked.” —Pico Iyer, Los Angeles Times Book Review</b><br/><br/><b>“A fantastic storyteller . . . an unsettling book . . . The four narrators Ricci creates are exceptionally well drawn and brilliantly infused with the details of their time.” —Ron Charles, <i>Christian Science Monitor</i></b><br/><br/><b>“The portrait of a difficult, alienated, but compassionate and charismatic intellectual and religious rebel . . . The character that emerges is complex, compelling, and achingly heroic.” —Christine Wald-Hopkins, <i>Denver Post and Rocky Mountain News</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nino Ricci
      </h2>
      
      <p class="authorDescription body article">NINO RICCI’s best-selling Lives of the Saints (published in the United States as The Book of Saints) won the Governor General’s Award for fiction, the SmithBooks/Books in Canada First Novel Award, and the F. G. Bressani Prize. It was the first book in a trilogy, followed by In a Glass House and Where She Has Gone, which was a finalist for the Giller Prize.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e7cdf4d